"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
require("core-js/modules/es.symbol.js");
require("core-js/modules/es.symbol.description.js");
require("core-js/modules/es.symbol.iterator.js");
require("core-js/modules/es.array.from.js");
require("core-js/modules/es.array.index-of.js");
require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.array.slice.js");
require("core-js/modules/es.object.assign.js");
require("core-js/modules/es.object.define-property.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
require("core-js/modules/es.object.keys.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.regexp.test.js");
require("core-js/modules/es.regexp.to-string.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useRadioHandler = exports.RadioGroup = exports.PresentationalRadioGroup = void 0;
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.function.name.js");
var _react = _interopRequireWildcard(require("react"));
var _useObservabilitySafe = require("../../../hooks/useObservabilitySafe");
var _index = require("../../index");
var _CheckboxOrRadio = require("../CheckboxOrRadio");
var _excluded = ["options", "selectedValue", "disabled", "errorMessage", "hasContainer", "name", "analyticsName", "trackImpression", "aria-label", "aria-labelledby", "role", "onClick", "containerProps"],
  _excluded2 = ["value"],
  _excluded3 = ["value"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function cov_i56qkotng() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Input/Radio/RadioGroup.tsx";
  var hash = "296b36a96538a09de4e2b30c31e99cbb93702ef5";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Input/Radio/RadioGroup.tsx",
    statementMap: {
      "0": {
        start: {
          line: 66,
          column: 81
        },
        end: {
          line: 141,
          column: 1
        }
      },
      "1": {
        start: {
          line: 82,
          column: 20
        },
        end: {
          line: 82,
          column: 93
        }
      },
      "2": {
        start: {
          line: 84,
          column: 2
        },
        end: {
          line: 108,
          column: 3
        }
      },
      "3": {
        start: {
          line: 85,
          column: 38
        },
        end: {
          line: 85,
          column: 48
        }
      },
      "4": {
        start: {
          line: 86,
          column: 4
        },
        end: {
          line: 107,
          column: 6
        }
      },
      "5": {
        start: {
          line: 97,
          column: 48
        },
        end: {
          line: 97,
          column: 62
        }
      },
      "6": {
        start: {
          line: 110,
          column: 2
        },
        end: {
          line: 140,
          column: 4
        }
      },
      "7": {
        start: {
          line: 120,
          column: 8
        },
        end: {
          line: 132,
          column: 10
        }
      },
      "8": {
        start: {
          line: 129,
          column: 48
        },
        end: {
          line: 129,
          column: 62
        }
      },
      "9": {
        start: {
          line: 150,
          column: 31
        },
        end: {
          line: 162,
          column: 1
        }
      },
      "10": {
        start: {
          line: 155,
          column: 42
        },
        end: {
          line: 155,
          column: 70
        }
      },
      "11": {
        start: {
          line: 156,
          column: 22
        },
        end: {
          line: 159,
          column: 3
        }
      },
      "12": {
        start: {
          line: 157,
          column: 4
        },
        end: {
          line: 157,
          column: 27
        }
      },
      "13": {
        start: {
          line: 158,
          column: 4
        },
        end: {
          line: 158,
          column: 61
        }
      },
      "14": {
        start: {
          line: 161,
          column: 2
        },
        end: {
          line: 161,
          column: 39
        }
      },
      "15": {
        start: {
          line: 168,
          column: 53
        },
        end: {
          line: 171,
          column: 1
        }
      },
      "16": {
        start: {
          line: 169,
          column: 40
        },
        end: {
          line: 169,
          column: 57
        }
      },
      "17": {
        start: {
          line: 170,
          column: 2
        },
        end: {
          line: 170,
          column: 100
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 66,
            column: 81
          },
          end: {
            line: 66,
            column: 82
          }
        },
        loc: {
          start: {
            line: 81,
            column: 6
          },
          end: {
            line: 141,
            column: 1
          }
        },
        line: 81
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 97,
            column: 42
          },
          end: {
            line: 97,
            column: 43
          }
        },
        loc: {
          start: {
            line: 97,
            column: 48
          },
          end: {
            line: 97,
            column: 62
          }
        },
        line: 97
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 119,
            column: 19
          },
          end: {
            line: 119,
            column: 20
          }
        },
        loc: {
          start: {
            line: 120,
            column: 8
          },
          end: {
            line: 132,
            column: 10
          }
        },
        line: 120
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 129,
            column: 42
          },
          end: {
            line: 129,
            column: 43
          }
        },
        loc: {
          start: {
            line: 129,
            column: 48
          },
          end: {
            line: 129,
            column: 62
          }
        },
        line: 129
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 150,
            column: 31
          },
          end: {
            line: 150,
            column: 32
          }
        },
        loc: {
          start: {
            line: 154,
            column: 5
          },
          end: {
            line: 162,
            column: 1
          }
        },
        line: 154
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 153,
            column: 55
          },
          end: {
            line: 153,
            column: 56
          }
        },
        loc: {
          start: {
            line: 153,
            column: 61
          },
          end: {
            line: 153,
            column: 63
          }
        },
        line: 153
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 156,
            column: 22
          },
          end: {
            line: 156,
            column: 23
          }
        },
        loc: {
          start: {
            line: 156,
            column: 41
          },
          end: {
            line: 159,
            column: 3
          }
        },
        line: 156
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 168,
            column: 53
          },
          end: {
            line: 168,
            column: 54
          }
        },
        loc: {
          start: {
            line: 168,
            column: 64
          },
          end: {
            line: 171,
            column: 1
          }
        },
        line: 168
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 68,
            column: 2
          },
          end: {
            line: 68,
            column: 20
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 68,
            column: 18
          },
          end: {
            line: 68,
            column: 20
          }
        }],
        line: 68
      },
      "1": {
        loc: {
          start: {
            line: 77,
            column: 2
          },
          end: {
            line: 77,
            column: 21
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 77,
            column: 9
          },
          end: {
            line: 77,
            column: 21
          }
        }],
        line: 77
      },
      "2": {
        loc: {
          start: {
            line: 84,
            column: 2
          },
          end: {
            line: 108,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 84,
            column: 2
          },
          end: {
            line: 108,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 84
      },
      "3": {
        loc: {
          start: {
            line: 97,
            column: 19
          },
          end: {
            line: 97,
            column: 62
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 97,
            column: 30
          },
          end: {
            line: 97,
            column: 39
          }
        }, {
          start: {
            line: 97,
            column: 42
          },
          end: {
            line: 97,
            column: 62
          }
        }],
        line: 97
      },
      "4": {
        loc: {
          start: {
            line: 101,
            column: 9
          },
          end: {
            line: 105,
            column: 16
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 102,
            column: 10
          },
          end: {
            line: 104,
            column: 17
          }
        }, {
          start: {
            line: 105,
            column: 12
          },
          end: {
            line: 105,
            column: 16
          }
        }],
        line: 101
      },
      "5": {
        loc: {
          start: {
            line: 114,
            column: 12
          },
          end: {
            line: 114,
            column: 45
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 114,
            column: 29
          },
          end: {
            line: 114,
            column: 33
          }
        }, {
          start: {
            line: 114,
            column: 36
          },
          end: {
            line: 114,
            column: 45
          }
        }],
        line: 114
      },
      "6": {
        loc: {
          start: {
            line: 129,
            column: 19
          },
          end: {
            line: 129,
            column: 62
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 129,
            column: 30
          },
          end: {
            line: 129,
            column: 39
          }
        }, {
          start: {
            line: 129,
            column: 42
          },
          end: {
            line: 129,
            column: 62
          }
        }],
        line: 129
      },
      "7": {
        loc: {
          start: {
            line: 134,
            column: 7
          },
          end: {
            line: 138,
            column: 14
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 135,
            column: 8
          },
          end: {
            line: 137,
            column: 15
          }
        }, {
          start: {
            line: 138,
            column: 10
          },
          end: {
            line: 138,
            column: 14
          }
        }],
        line: 134
      },
      "8": {
        loc: {
          start: {
            line: 152,
            column: 2
          },
          end: {
            line: 152,
            column: 27
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 152,
            column: 25
          },
          end: {
            line: 152,
            column: 27
          }
        }],
        line: 152
      },
      "9": {
        loc: {
          start: {
            line: 153,
            column: 2
          },
          end: {
            line: 153,
            column: 63
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 153,
            column: 55
          },
          end: {
            line: 153,
            column: 63
          }
        }],
        line: 153
      },
      "10": {
        loc: {
          start: {
            line: 155,
            column: 51
          },
          end: {
            line: 155,
            column: 69
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 155,
            column: 51
          },
          end: {
            line: 155,
            column: 63
          }
        }, {
          start: {
            line: 155,
            column: 67
          },
          end: {
            line: 155,
            column: 69
          }
        }],
        line: 155
      },
      "11": {
        loc: {
          start: {
            line: 158,
            column: 4
          },
          end: {
            line: 158,
            column: 60
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 158,
            column: 4
          },
          end: {
            line: 158,
            column: 11
          }
        }, {
          start: {
            line: 158,
            column: 15
          },
          end: {
            line: 158,
            column: 60
          }
        }],
        line: 158
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0
    },
    b: {
      "0": [0],
      "1": [0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0],
      "9": [0],
      "10": [0, 0],
      "11": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "296b36a96538a09de4e2b30c31e99cbb93702ef5"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_i56qkotng = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_i56qkotng();
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
/**
 * INSTRUCTIONS FOR RADIO GROUP:
 *   There are two types of components for radio group:
 *   option 1) Presentational radio group that is just there for design
 *   option 2) A stateful radio group that handles all the default logic for the consumer
 *   Please choose the one that is best suited for your needs
 */
/**
 * OPTION 1: PRESENTATIONAL RADIO GROUP
 * Radio Group is purely presentational
 * This does not handle keeping track of selected values handleChange & handleClick. Consumer must handle these themselves.
 * If you would like the bricks component to handle this please use RadioGroup which is a combination of PresentationalRadioGroup & the hook with default logic
 */
cov_i56qkotng().s[0]++;
var PresentationalRadioGroup = exports.PresentationalRadioGroup = function PresentationalRadioGroup(_ref) {
  var options = _ref.options,
    _ref$selectedValue = _ref.selectedValue,
    selectedValue = _ref$selectedValue === void 0 ? (cov_i56qkotng().b[0][0]++, '') : _ref$selectedValue,
    disabled = _ref.disabled,
    errorMessage = _ref.errorMessage,
    hasContainer = _ref.hasContainer,
    name = _ref.name,
    analyticsName = _ref.analyticsName,
    trackImpression = _ref.trackImpression,
    ariaLabel = _ref['aria-label'],
    ariaLabelBy = _ref['aria-labelledby'],
    _ref$role = _ref.role,
    role = _ref$role === void 0 ? (cov_i56qkotng().b[1][0]++, 'radiogroup') : _ref$role,
    onClick = _ref.onClick,
    containerProps = _ref.containerProps,
    props = _objectWithoutProperties(_ref, _excluded);
  cov_i56qkotng().f[0]++;
  var inViewRef = (cov_i56qkotng().s[1]++, (0, _useObservabilitySafe.useTrackComponentInView)('radioViewEvent', trackImpression, analyticsName));
  cov_i56qkotng().s[2]++;
  if (options.length === 1) {
    cov_i56qkotng().b[2][0]++;
    var _ref2 = (cov_i56qkotng().s[3]++, options[0]),
      _value = _ref2.value,
      optionProps = _objectWithoutProperties(_ref2, _excluded2);
    cov_i56qkotng().s[4]++;
    return /*#__PURE__*/_react["default"].createElement(_index.Flex, _extends({
      ref: inViewRef,
      flexDirection: "column"
    }, containerProps), /*#__PURE__*/_react["default"].createElement(_CheckboxOrRadio.Radio, _extends({
      analyticsName: analyticsName,
      checked: selectedValue === _value,
      disabled: disabled,
      errorMessage: errorMessage,
      hasContainer: hasContainer,
      key: _value,
      name: name,
      value: _value,
      onClick: disabled ? (cov_i56qkotng().b[3][0]++, undefined) : (cov_i56qkotng().b[3][1]++, function () {
        cov_i56qkotng().f[1]++;
        cov_i56qkotng().s[5]++;
        return onClick(_value);
      })
    }, optionProps, props)), errorMessage !== undefined ? (cov_i56qkotng().b[4][0]++, /*#__PURE__*/_react["default"].createElement(_index.Text, {
      color: "red50",
      fontSize: "s1",
      "data-testid": 'error messaging'
    }, errorMessage)) : (cov_i56qkotng().b[4][1]++, null));
  } else {
    cov_i56qkotng().b[2][1]++;
  }
  cov_i56qkotng().s[6]++;
  return /*#__PURE__*/_react["default"].createElement(_index.Flex, _extends({
    ref: inViewRef,
    flexDirection: "column",
    role: role != 'none' ? (cov_i56qkotng().b[5][0]++, role) : (cov_i56qkotng().b[5][1]++, undefined),
    "aria-label": ariaLabel,
    "aria-labelledby": ariaLabelBy
  }, containerProps), options.map(function (_ref3) {
    var value = _ref3.value,
      optionProps = _objectWithoutProperties(_ref3, _excluded3);
    cov_i56qkotng().f[2]++;
    cov_i56qkotng().s[7]++;
    return /*#__PURE__*/_react["default"].createElement(_CheckboxOrRadio.Radio, _extends({
      analyticsName: analyticsName,
      checked: selectedValue === value,
      disabled: disabled,
      errorMessage: errorMessage,
      hasContainer: hasContainer,
      key: value,
      name: name,
      value: value,
      onClick: disabled ? (cov_i56qkotng().b[6][0]++, undefined) : (cov_i56qkotng().b[6][1]++, function () {
        cov_i56qkotng().f[3]++;
        cov_i56qkotng().s[8]++;
        return onClick(value);
      })
    }, optionProps, props));
  }), errorMessage !== undefined ? (cov_i56qkotng().b[7][0]++, /*#__PURE__*/_react["default"].createElement(_index.Text, {
    color: "red50",
    fontSize: "s1",
    "data-testid": 'error messaging'
  }, errorMessage)) : (cov_i56qkotng().b[7][1]++, null));
};

/**
 * This hook handles keeping track of selected values & the handleClick.
 * It is used in the stateful radio group that handles all the default logic for the consumer
 * useRadioHandler handles:
 *   1) default radio handling logic
 *   2) keeps track of checked values
 */
cov_i56qkotng().s[9]++;
var useRadioHandler = exports.useRadioHandler = function useRadioHandler() {
  var _ref6;
  var initialValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (cov_i56qkotng().b[8][0]++, '');
  var onClick = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (cov_i56qkotng().b[9][0]++, function () {
    cov_i56qkotng().f[5]++;
  });
  cov_i56qkotng().f[4]++;
  var _ref4 = (cov_i56qkotng().s[10]++, (0, _react.useState)((_ref6 = (cov_i56qkotng().b[10][0]++, initialValue)) !== null && _ref6 !== void 0 ? _ref6 : (cov_i56qkotng().b[10][1]++, ''))),
    _ref5 = _slicedToArray(_ref4, 2),
    checkedValue = _ref5[0],
    setCheckedValue = _ref5[1];
  cov_i56qkotng().s[11]++;
  var handleClick = function handleClick(value) {
    cov_i56qkotng().f[6]++;
    cov_i56qkotng().s[12]++;
    setCheckedValue(value);
    cov_i56qkotng().s[13]++;
    (cov_i56qkotng().b[11][0]++, onClick) && (cov_i56qkotng().b[11][1]++, onClick(checkedValue, checkedValue === value));
  };
  cov_i56qkotng().s[14]++;
  return {
    checkedValue: checkedValue,
    handleClick: handleClick
  };
};

/**
 * OPTION 2: STATEFUL RADIO GROUP: A stateful radio group that handles all the default logic for the consumer
 *   This radio group keeps track of selected values & the handleClick by calling the useRadioHandler
 */
cov_i56qkotng().s[15]++;
var RadioGroup = exports.RadioGroup = function RadioGroup(props) {
  cov_i56qkotng().f[7]++;
  var _ref7 = (cov_i56qkotng().s[16]++, useRadioHandler()),
    checkedValue = _ref7.checkedValue,
    handleClick = _ref7.handleClick;
  cov_i56qkotng().s[17]++;
  return /*#__PURE__*/_react["default"].createElement(PresentationalRadioGroup, _extends({
    selectedValue: checkedValue,
    onClick: handleClick
  }, props));
};